import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FilePresentation = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 18.113V7C26 4.237 23.762 2 21 2H11C8.238 2 6 4.237 6 7V23C6 25.762 8.238 28 11 28H16.113C17.375 29.238 19.101 30 21 30C24.863 30 28 26.863 28 23C28 21.1 27.238 19.375 26 18.113ZM8 23V7C8 5.35 9.35 4 11 4H21C22.65 4 24 5.35 24 7V16.675C23.087 16.237 22.075 16 21 16C17.137 16 14 19.137 14 23C14 24.075 14.238 25.087 14.675 26H11C9.35 26 8 24.65 8 23ZM16.825 25.75C16.3 24.962 16 24.012 16 23C16 20.587 17.725 18.562 20 18.1V22.588L16.825 25.751V25.75ZM21 28C19.988 28 19.038 27.687 18.25 27.175L21.425 24H25.913C25.438 26.275 23.413 28 21 28ZM22 22V18.1C23.95 18.5 25.5 20.038 25.9 22H22Z" />
		<path d="M13 18H11C10.45 18 10 17.55 10 17C10 16.45 10.45 16 11 16H13C13.55 16 14 16.45 14 17C14 17.55 13.55 18 13 18Z" />
		<path d="M17 14H11C10.45 14 10 13.55 10 13C10 12.45 10.45 12 11 12H17C17.55 12 18 12.45 18 13C18 13.55 17.55 14 17 14Z" />
		<path d="M21 10H11C10.45 10 10 9.55 10 9C10 8.45 10.45 8 11 8H21C21.55 8 22 8.45 22 9C22 9.55 21.55 10 21 10Z" />
	</svg>
);

export default FilePresentation;
